<template>
  <el-container>
    <el-main>
      <el-row class="el-menu-demo">
        <el-col :md="2">
          <ul role="menubar" class="el-menu--horizontal el-menu">
            <li role="menuitem" class="el-menu-item">
              <a href="/blog" style="color: #007bff;text-decoration-line: none">
                <img src="@/assets/img/logo.png" class="logo" alt="img">
                MyBlog
              </a>
            </li>
          </ul>
        </el-col>
        <el-col :md="8">
          <el-menu
            class="el-menu--horizontal el-menu"
            :default-active="this.$route.path"
            router
            mode="horizontal"
          >
            <el-menu-item index="/blog/category">
              <template slot="title">
                <span style="color: #007bff">分类</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/blog/tag">
              <template slot="title">
                <span style="color: #007bff">标签</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/blog/archive">
              <template slot="title">
                <span style="color: #007bff">归档</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/blog/about">
              <template slot="title">
                <span style="color: #007bff">关于</span>
              </template>
            </el-menu-item>
          </el-menu>
        </el-col>
        <el-col :md="6">
          <ul class="el-menu--horizontal el-menu">
            <li class="el-menu-item">
              <el-autocomplete
                v-model="keyword"
                :placeholder="searchHint"
                clearable
                suffix-icon="el-icon-search"
                size="medium"
                :debounce="1000"
                @keyup.enter.native="onSearch"
                @select="onSearch"
              />
            </li>
          </ul>
        </el-col>
      </el-row>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Blog',
  data() {
    return {
      searchHint: '搜索文章',
      keyword: ''
    }
  },
  watch: {
    $route() {
      this.$router.go()
    }
  },
  created() {
    document.title = 'MyBlog'
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    onSearch() {
      // 正则去空格
      if (this.keyword.replace(/\s*/g, '')) {
        this.toSearchPage()
      } else {
        this.$message({
          showClose: true,
          message: '不能为空！',
          type: 'warning'
        })
      }
    },
    // 跳转搜索页面，传递搜索框的参数
    toSearchPage() {
      const currentPath = this.$route.path
      if (currentPath === '/blog/search') {
        this.$router.push({
          path: '/blog/search',
          query: {
            kw: this.keyword,
            pn: 1
          }
        })
        this.$router.go(0)
      } else {
        const routeUrl = this.$router.resolve({
          path: '/blog/search',
          query: {
            kw: this.keyword,
            pn: 1
          }
        })
        window.open(routeUrl.href, '_blank')
      }
    }
  }
}
</script>

<style>
.logo {
  width: 30px;
  position: relative;
}
</style>
